import { createFileRoute } from '@tanstack/react-router'

import type { ConfiguratorSearch } from '@/components/Public/Configurator/parse-property-params'
import { PublicConfiguratorPage } from '@/components/Public/Configurator/PublicConfiguratorPage'

function PublicConfigurator() {
  return <PublicConfiguratorPage params={Route.useSearch()} />
}

export const Route = createFileRoute('/public/configurator/')({
  validateSearch: (search: Record<string, unknown>): ConfiguratorSearch =>
    Object.fromEntries(
      Object.entries(search).flatMap(([key, value]) =>
        typeof value === 'string' ? [[key, value]] : [],
      ),
    ),
  component: PublicConfigurator,
})
